import BaseRoute from "../../../lib/itn-ui-kit/route/base-route";

import Template from "./template";

export default class DashboardRoute extends BaseRoute {
  element = (<Template />);
  path = "";

  async loader() {
    return {};
  }
}
